import { node } from 'prop-types';

const Checkbox = (props) => {
  return props.children;
};

Checkbox.propTypes = {
  /** The only thing that renders */
  children: node,
};

export default Checkbox;
